import { render } from "./AdminLanding.vue?vue&type=template&id=9994e79a"
import script from "./AdminLanding.vue?vue&type=script&lang=js"
export * from "./AdminLanding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/AdminLanding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9994e79a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9994e79a', __exports__)) {
    api.reload('9994e79a', __exports__)
  }
  
  module.hot.accept("./AdminLanding.vue?vue&type=template&id=9994e79a", () => {
    api.rerender('9994e79a', render)
  })

}


export default __exports__